var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-page',[_c('SignedInHeader'),_c('ion-content',[_c('SwipeTransition',[_c('router-view',{key:_vm.$route.params.id})],1)],1),_c('ion-footer',[_c('AddAlertProgress',{attrs:{"progress":_vm.progress}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }